(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.NBBDiscountPage = api;
    var start = function () {
      var core = root.NBBDiscountPageCore;
      if (!core) return;
      root.document.querySelectorAll('[data-discount-page]').forEach(function (element) {
        if (!element.dataset.discountPageReady) api.create(element, { core: core });
      });
    };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var SOURCE = 'discount_page_v1';
  var STANDARD_FORM_SELECTOR = '[class*="klaviyo-form-"]';

  function suppressStandardPopup(root) {
    if (root.dataset.suppressStandardPopup !== 'true') return;
    var doc = root.ownerDocument;
    var win = doc.defaultView;

    function hide() {
      doc.querySelectorAll(STANDARD_FORM_SELECTOR).forEach(function (formRoot) {
        var container = formRoot.closest('[role="dialog"]') || formRoot;
        container.hidden = true;
        container.setAttribute('aria-hidden', 'true');
        if (container.style) container.style.setProperty('display', 'none', 'important');
        if (doc.body.style.overflow === 'hidden') doc.body.style.removeProperty('overflow');
      });
    }

    hide();
    if (typeof win.MutationObserver === 'function') {
      var observer = new win.MutationObserver(hide);
      observer.observe(doc.body, { childList: true, subtree: true });
    }
  }

  function create(root, dependencies) {
    if (!root || root.dataset.discountPageReady) return null;
    dependencies = dependencies || {};
    var win = root.ownerDocument.defaultView;
    var core = dependencies.core || win.NBBDiscountPageCore;
    var fetcher = dependencies.fetch || (win.fetch && win.fetch.bind(win));
    var clipboard = dependencies.clipboard || (win.navigator && win.navigator.clipboard);
    var now = dependencies.now || function () { return new Date(); };
    var turnstile = dependencies.turnstile || win.turnstile;
    var analytics = dependencies.analytics || win.NBBAnalytics;
    var form = root.querySelector('[data-discount-form]');
    var email = root.querySelector('[data-discount-email]');
    var submitButton = root.querySelector('[data-discount-submit]');
    var error = root.querySelector('[data-form-error]');
    var success = root.querySelector('[data-discount-success]');
    var coupon = root.querySelector('[data-coupon-code]');
    var expiry = root.querySelector('[data-coupon-expiry]');
    var status = root.querySelector('[data-success-status]');
    var copyButton = root.querySelector('[data-copy-code]');
    var copySurface = root.querySelector('[data-copy-code-surface]');
    var copyHint = root.querySelector('[data-copy-hint]');
    var turnstileMount = root.querySelector('[data-turnstile]');
    var state = { token: '', widgetId: null, submitting: false, result: null, turnstileAttempts: 0 };

    if (!core || !form || !email || !submitButton || !error || !success || !coupon || !expiry) return null;
    root.dataset.discountPageReady = 'true';
    suppressStandardPopup(root);

    function errorCategory(errorCode) {
      if (/^invalid_/.test(errorCode || '')) return 'validation';
      if (/^verification_/.test(errorCode || '')) return 'turnstile';
      if (errorCode === 'copy_unavailable') return 'clipboard';
      if (errorCode === 'service_unavailable' || errorCode === 'signup_unavailable' || errorCode === 'offer_expired') return 'worker';
      return 'network';
    }

    function emit(eventName, errorCode, analyticsExtra) {
      var detail = { event: eventName, source: SOURCE };
      if (errorCode) detail.errorCode = errorCode;
      root.dispatchEvent(new win.CustomEvent('nbb:discount-page', { bubbles: true, detail: detail }));
      if (!analytics || typeof analytics.publish !== 'function') return;
      var mapped = {
        view: 'discount_page_viewed',
        submit: 'discount_claim_started',
        success: 'discount_claim_completed',
        copy: 'discount_coupon_copied',
        shop_click: 'discount_shop_clicked',
        error: 'discount_error'
      }[eventName];
      if (!mapped) return;
      var payload = Object.assign({ page_type: 'page', locale: root.dataset.lang || 'en' }, analyticsExtra || {});
      if (errorCode) payload.error_category = errorCategory(errorCode);
      analytics.publish(mapped, payload);
    }

    function showError(message, errorCode, focusTarget) {
      error.hidden = false;
      error.textContent = message;
      var target = focusTarget || error;
      if (target && typeof target.focus === 'function') target.focus();
      if (errorCode) emit('error', errorCode);
    }

    function clearError() {
      error.textContent = '';
      error.hidden = true;
    }

    function setSubmitting(active) {
      state.submitting = active;
      submitButton.disabled = active;
      submitButton.textContent = active ? 'Creating your code…' : 'Reveal my 10% code';
    }

    function resetTurnstile() {
      state.token = '';
      if (turnstile && state.widgetId !== null && typeof turnstile.reset === 'function') {
        try { turnstile.reset(state.widgetId); } catch (_error) {}
      }
    }

    function handleTurnstileFailure(message, errorCode) {
      state.token = '';
      showError(message, errorCode);
      if (turnstile && state.widgetId !== null && typeof turnstile.reset === 'function') {
        try { turnstile.reset(state.widgetId); } catch (_error) {}
      }
    }

    function renderTurnstile() {
      turnstile = dependencies.turnstile || win.turnstile;
      if (state.widgetId !== null || !turnstileMount) return;
      if (!turnstile || typeof turnstile.render !== 'function') {
        state.turnstileAttempts += 1;
        if (state.turnstileAttempts < 20 && typeof win.setTimeout === 'function') win.setTimeout(renderTurnstile, 250);
        else showError('The security check could not load. Refresh the page and try again.', 'verification_unavailable');
        return;
      }
      state.widgetId = turnstile.render(turnstileMount, {
        sitekey: root.dataset.turnstileSiteKey,
        action: root.dataset.turnstileAction || 'discount_page_signup',
        theme: 'light',
        size: 'flexible',
        callback: function (token) { state.token = token || ''; clearError(); },
        'expired-callback': function () {
          handleTurnstileFailure('The security check expired. Complete it again, then reveal your code.', 'verification_expired');
        },
        'error-callback': function () {
          handleTurnstileFailure('The security check could not load. Refresh the page and try again.', 'verification_unavailable');
        },
        'timeout-callback': function () {
          handleTurnstileFailure('The security check expired. Complete it again, then reveal your code.', 'verification_expired');
        }
      });
    }

    async function parseResponse(response) {
      try { return await response.json(); } catch (_error) { return null; }
    }

    async function onSubmit(event) {
      event.preventDefault();
      if (state.submitting || state.result) return;
      clearError();
      if (!core.isValidEmail(email.value)) {
        showError('Enter a valid email address.', 'invalid_email', email);
        return;
      }
      if (!state.token) {
        showError('Complete the security check, then reveal your code.', 'verification_required');
        return;
      }
      if (!fetcher || !root.dataset.signupEndpoint) {
        showError('Your code could not be created. Check your connection and try again.', 'service_unavailable');
        return;
      }

      setSubmitting(true);
      emit('submit');
      try {
        var response = await fetcher(root.dataset.signupEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(core.buildSignupPayload(email.value, {
            lang: root.dataset.lang,
            turnstileToken: state.token
          }))
        });
        var payload = await parseResponse(response);
        var result = response.ok ? core.safeResult(payload) : null;
        if (!result) throw new Error(payload && payload.error === 'verification_failed' ? 'verification_failed' : 'signup_unavailable');
        if (core.isExpired(result.expiresAt, now())) {
          showError('This offer was already claimed and has expired. The code cannot be issued again.', 'offer_expired');
          resetTurnstile();
          return;
        }
        state.result = result;
        coupon.textContent = result.couponCode;
        expiry.textContent = core.formatExpiry(result.expiresAt, root.dataset.lang);
        expiry.setAttribute('datetime', result.expiresAt);
        form.hidden = true;
        success.hidden = false;
        if (status) status.textContent = 'Your unique 10% code is ready.';
        emit('success', null, { is_returning_claim: Boolean(result.isReturningClaim) });
        if (copySurface && typeof copySurface.focus === 'function') copySurface.focus();
      } catch (requestError) {
        var code = requestError && requestError.message === 'verification_failed' ? 'verification_failed' : 'signup_unavailable';
        var message = code === 'verification_failed'
          ? 'The security check expired. Complete it again and retry.'
          : 'Your code could not be created. Check your connection and try again.';
        showError(message, code);
        resetTurnstile();
      } finally {
        setSubmitting(false);
      }
    }

    async function onCopy() {
      if (!state.result || !clipboard || typeof clipboard.writeText !== 'function') return;
      try {
        await clipboard.writeText(state.result.couponCode);
        copyButton.textContent = 'Code copied';
        if (copyHint) copyHint.textContent = 'Copied';
        if (status) status.textContent = 'Code copied to your clipboard.';
        emit('copy');
      } catch (_error) {
        if (status) status.textContent = 'Select the code and copy it manually.';
        emit('error', 'copy_unavailable');
      }
    }

    function onDestinationClick(event) {
      var destination = event.target.closest('[data-discount-destination]');
      if (!destination || !root.contains(destination)) return;
      emit('shop_click', null, {
        destination_type: destination.dataset.destinationType || 'collection',
        destination_handle: destination.dataset.destinationHandle || '',
        destination_position: Number(destination.dataset.destinationPosition) || 0
      });
    }

    form.addEventListener('submit', onSubmit);
    if (copyButton) copyButton.addEventListener('click', onCopy);
    if (copySurface) copySurface.addEventListener('click', onCopy);
    root.addEventListener('click', onDestinationClick);
    renderTurnstile();
    emit('view');
    return { submit: onSubmit };
  }

  return { create: create };
});
